export default {
  agreeTitle:
    'Vereinbarung über die Marketingdienstleistungen durch das „acbuy Affiliate“-Programm auf der acbuy-Website',
  agreementText:
    'Willkommen zur Registrierung auf der acbuy-Website und zur Nutzung der Marketingdienstleistungen des „acbuy Affiliate“-Programms. Diese Vereinbarung wird zwischen den Partnern des „acbuy Affiliate“-Programms (im Folgenden „Partner B“) und acbuy (im Folgenden „Partner A“) (einschließlich, aber nicht beschränkt auf www.acbuy.com, die mobile App von acbuy usw., im Folgenden „Website von Partner A“) hinsichtlich der Angelegenheiten im Zusammenhang mit den Marketingdienstleistungen des „acbuy Affiliate“-Programms geschlossen. Partner B hat alle Texte hierin, insbesondere die fettgedruckten Teile, sorgfältig zu lesen, bevor er die Marketingdienstleistungen des „acbuy Affiliate“-Programms auf der acbuy-Website nutzt, und durch Klicken auf die Schaltfläche „Ich habe es gelesen und stimme zu“ gilt Partner B als mit den Spezifikationen hierin einverstanden und verpflichtet, diese einzuhalten. Die Vereinbarung stellt die Vereinbarung zwischen Partner B und acbuy dar und hat Rechtskraft. acbuy ist berechtigt, die Artikel hierin einseitig aufgrund seiner geschäftlichen Bedürfnisse zu ändern, und acbuy wird solche Änderungen im Falle von Änderungen der Artikel hierin unverzüglich auf der Website von Partner A veröffentlichen, und Partner B hat die Nutzung der Marketingdienstleistungen über den Kanal des „acbuy Affiliate“-Programms unverzüglich einzustellen, falls Partner B den Änderungen der Texte hierin nicht zustimmt, andernfalls gilt Partner B als mit den Änderungen der Texte hierin einverstanden.\nArtikel 1 Definitionen 1. Verbraucher: bezeichnet ein acbuy-Mitglied, das zum Zweck der Registrierung auf die Website von Partner A zugreift.',
  dashboard: 'Dashboard',
  hi: 'Hallo, ',
  inviteFriends: 'Freunde einladen',
  inviteFriendsTips:
    'Lade Freunde zu acbuy ein und verdiene mehr Geld! Je mehr du einlädst, desto mehr verdienst du, ohne Limit.',
  inviteFriendsTips1:
    'Lade 3 aktive Konten ein, um Verkaufsrechte zu erhalten und Provisionen zu verdienen.',
  totalInvite: 'Gesamtzahl der eingeladenen Nutzer',
  myTeam: 'Mein Team',
  extractMoney: 'Auszahlung abgeschlossen',
  noExtractMoney: 'Nicht ausgezahlte Provision',
  inviteTitle: 'Meine Freunde einladen',
  copyCode: 'Einladungscode kopieren',
  poster: 'Exklusives Poster',
  myLevel: 'Mein Privileg',
  youLevel: 'Ihr aktuelles Level',
  commissionRate: 'Provisionssatz',
  experienceValue: 'Erfahrungswert ({num}/{total})',
  levelDesc: 'Level-Beschreibung',
  invite: 'Einladen',
  revenueDetails: 'Einladungsdetails',
  registerTime: 'Registrierungszeit',
  inviteType: 'Verwandte Beziehungen',
  userMail: 'Benutzername (E-Mail)',
  bonus: 'Bonus',
  myBonus: 'Mein Bonus',
  myBalance: 'Mein Guthaben',
  applyWithdraw: 'Auszahlung beantragen',
  withdrawTips:
    'Hinweis: Aufgrund der mit der Auszahlung verbundenen Transaktionsgebühr wird empfohlen, einen Betrag von mehr als 500,00 ¥ auszuzahlen.',
  bank: 'Bank',
  paypalAccount: 'PayPal-Konto',
  bankAccount: 'Bankkonto',
  bankName: 'Bankname',
  withdrawAmount: 'Auszahlungsbetrag ({unit})',
  bonusDetail: 'Bonusdetails',
  directCommission: 'Details zur direkten Provision',
  indirectCommission: 'Details zur indirekten Provision',
  tradeTime: 'Transaktionszeit',
  packNo: 'Paketnummer',
  actCommission: 'Provision',
  settlementTime: 'Abrechnungszeit',
  levelName: 'Botschafter-Level',
  packStatus: 'Paketstatus',
  directExplain: 'Provisionssatz',
  indirectExplain: 'Provision auf die Versandkosten der sekundären Eingeladenen',
  experienceExplain: 'Erfahrungswert',
  withdrawRecord: 'Auszahlungshistorie',
  withdrawTime: 'Auszahlungszeit',
  serialNo: 'Seriennummer',
  withdrawStatus: 'Auszahlungsstatus',
  team: 'Team',
  levelUp: 'Level aufsteigen',
  teamInfo: 'Teaminformationen',
  teamNum: 'Anzahl der Teamnutzer',
  monthCommission: 'Geschätzte Provision für diesen Monat',
  accCommission: 'Kumulierte Auszahlungsprovision',
  teamMember: 'Teammitglied',
  promotedMember: 'Beworbenes Mitglied',
  invitationTime: 'Einladungszeit',
  inviter: 'Einlader',
  promotionTime: 'Beförderungszeit',
  IBAN: 'IBAN',
  swiftCode: 'SWIFT-Code',
  bankAddress: 'Bankadresse',
  setting: 'Einstellungen',
  profile: 'Profil',
  withdrawMethod: 'Auszahlungsmethode',
  myPrerogative: 'Mein Privileg',
  verifyEmail: 'E-Mail verifizieren',
  sendCodeTips:
    'Wir haben einen Verifizierungscode an <strong>{email}</strong> gesendet. Geben Sie den Code unten ein, um ihn zu verifizieren.',
  noGetEmail: 'Sie haben Ihre E-Mail nicht erhalten?',
  codeErrorTips: 'Code-Fehler, bitte versuchen Sie es erneut',
  resendTime: 'Code erneut senden ({time}s)',
  or: 'oder',
  contactService: 'Online-Kundenservice kontaktieren',
  addMethod: 'Neue Auszahlungsmethode',
  editMethod: 'Auszahlungsmethode bearbeiten',
  rePaypalAccount: 'PayPal-Konto erneut eingeben',
  directInvite: 'Direkte Einladung',
  indirectInvite: 'Indirekte Einladung',
  noSameAccount: 'Das Konto unterscheidet sich vom bestätigten Konto',
  noAddWithdrawMethod: 'Sie haben keine Auszahlungsmethode hinzugefügt',
  statusEnum: {
    0: 'Wird ausgestellt',
    1: 'In Freigabe',
    2: 'Freigabe erfolgreich',
    3: 'Bereitstellung fehlgeschlagen',
    4: 'Auszahlungsstornierung',
  },
  userDetail: 'Nutzerdetails',
  balance: 'Kontostand',
  withdrawMax: 'Betrag über 500,00 ¥',
  addPaypalAccount: 'PayPal-Konto hinzufügen',
  addBankAccount: 'Bankkonto hinzufügen',
  noPaypalAccount: 'Kein PayPal-Konto',
  noBankAccount: 'Kein Bankkonto',
  estimated: 'Zugestellt',
  notEstimated: 'Nicht zugestellt',
  actual: 'Tatsächlich',
  estiamte: 'Geschätzt',
  directRealtion: 'Direkte Beziehung',
  indirectRealtion: 'Indirekte Beziehung',
  experienceValueText: 'Erfahrungswert',
  relatedParcel: 'Zugehöriges Paket',
  empiricalValue: 'Erfahrungswert',
  acquiringTime: 'Erwerbszeit',
  relatedEmail: 'Zugehörige E-Mail',
  relatedUsers: 'Zugehörige Nutzer',
  balanceDetail: 'Guthabendetails',
  commissionDetail: 'Provisionsdetails',
  details: 'Details',
  question1:
    'Nachdem der eingeladene Nutzer den Beutel fertiggestellt hat, wird sein Status auf „Aktiviert“ aktualisiert.',
  question2:
    'Die Bestellung wurde abgeschlossen und die Provision wurde Ihrem Guthabenkonto gutgeschrieben.',
  question3:
    'Provision für alle Bestellungen mit dem Status „Zahlungseingang bestätigen“. Die Bestellung wird innerhalb von 30-60 Tagen überprüft, und anschließend wird die Provision Ihrem Guthabenkonto gutgeschrieben.',
  activatedUser: 'Aktivierter Nutzer',
  bankTip: 'Auszahlungsgebühr: 2% des Auszahlungsbetrags',
  selectWithdrawMethod: 'Auszahlungskonto auswählen',
  currentWithdrawAmount: 'Aktuell auszahlbarer Betrag',
  modify: 'Ändern',
  bonusBalance: 'Verfügbares Bonusguthaben',
  balanceTips1:
    '1. Auszahlung der Abrechnungsprovision für den Vormonat am 1. (UTC+8) jedes Monats',
  balanceTips2:
    '2. Der 1. (UTC+8) bis 10. (UTC+8) jedes Monats ist der Auszahlungstermin, und Sie können vom 1. (UTC+8) bis zum 10. (UTC+8) auszahlen. Wir überweisen Ihnen die Gelder vor dem 20. (UTC+8) und benachrichtigen Sie nach der Überweisung per E-Mail über das Ergebnis. Gleichzeitig können Sie die Überweisungsinformationen in der Auszahlungshistorie einsehen.',
  income: 'Einnahmen',
  expenditure: 'Ausgaben',
  commissionSettlement: 'Provisionsabrechnung',
  commissionWithdrawal: 'Provisionsauszahlung',
  withdrawalCancellation: 'Auszahlungsstornierung',
  activeStatus: 'Aktiver Status',
  settlePackageNum: 'Paketmenge',
  activeTime: 'Aktivierungszeit',
  orderTime: 'Zeitpunkt der Paketeinreichung',
  orderUser: 'Bestellender Nutzer',
  actualFreight: 'Tatsächliche Frachtzahlung',
  estimatedCommission: 'Geschätzte Provision',
  withdrawAccount: 'Auszahlungskonto',
  withdrawType: 'Auszahlungstyp',
  withdrawTypeEnum: {
    2: 'Auszahlung auf Guthaben',
    0: 'Auszahlung auf Bankkonto',
  },
  applyTime: 'Antragsdatum',
  withdrawStatusEnum: {
    0: 'In Prüfung',
    1: 'Wird ausgezahlt',
    2: 'Auszahlung erfolgreich',
    3: 'Auszahlung abgelehnt',
    4: 'Auszahlung storniert',
  },
  bankEndNumber: 'Endziffer der Bankkarte',
  cancelWithdraw: 'Auszahlung stornieren',
  withdrawalDetails: 'Auszahlungsdetails',
  transferVoucher: 'Überweisungsbeleg',
  cancelWithdrawConfirm: 'Bestätigung der Auszahlungsstornierung',
  delPackageHint:
    'Nach Bestätigung der Stornierung der Auszahlung wird der entsprechende Auszahlungsbetrag Ihrem Provisionsguthaben gutgeschrieben.',
  withdrawTip:
    'Der 1. (UTC+8) bis 10. (UTC+8) jedes Monats sind Auszahlungstage, und Sie können vom 1. (UTC+8) bis zum 10. (UTC+8) auszahlen.',
  hasLogOff: 'Abmelden',
}
